import restful from '../vuex'
import axios from 'axios'

const state = {
  ...restful.states('category'),
  all_categories: []
}

const getters = {
  ...restful.getters('category'),
  all_categories: (state) => state.all_categories
}

const actions = {
  ...restful.actions('categories'),
  async allCategory ({ commit }) {
    const res = await axios.get('categories?per=10000')
    commit('all_categories', res.data)
  }
}

const mutations = {
  ...restful.mutations('category'),
  all_categories (state, all_categories) {
    state.all_categories = all_categories
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
